import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { YOUTUBE_PLAYER_CONFIG, YouTubePlayer } from '@angular/youtube-player';

@Component({
  selector: 'app-youtube-player',
  standalone: true,
  imports: [YouTubePlayer],
  providers: [
    {
      provide: YOUTUBE_PLAYER_CONFIG,
      useValue: {
        disablePlaceholder: true,
      },
    },
  ],
  templateUrl: './youtube-player.component.html',
  styleUrl: './youtube-player.component.css',
})
export class YoutubePlayerComponent {
  @ViewChild('youTubePlayer') youTubePlayer:
    | ElementRef<HTMLDivElement>
    | undefined;

  videoHeight: number | undefined;
  videoWidth: number | undefined;

  @Input('videoID') videoID: string = '';

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.onResize();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  onResize(): void {
    // you can remove this line if you want to have wider video player than 1200px
    this.videoWidth = Math.min(
      (this.youTubePlayer as ElementRef<HTMLDivElement>).nativeElement
        .clientWidth,
      1200
    );
    // so you keep the ratio
    this.videoHeight = this.videoWidth * 0.6;
    this.changeDetectorRef.detectChanges();
  }
}
